/* .nomcaché — Judge.me review translation renderer. */
(function () {
  'use strict';

  if (window.__nomcacheJudgeMeReviewTranslationRenderer) return;

  var REVIEW_DATA = window.__NOMCACHE_JUDGEME_REVIEW_TRANSLATIONS__ || {};
  var WIDGET_SELECTOR = '#judgeme_product_reviews';
  var REVIEW_SELECTOR = '.jm-review-item[review-uuid]';
  var TITLE_SELECTOR =
    '.jm-review-content__title, .jdgm-rev__title, [data-testid="review-title"]';
  var BODY_SELECTOR =
    '.jm-review-content__body .jdgm-review-content__body-content > p, ' +
    '.jdgm-rev__body, [data-testid="review-body"]';
  var widget;
  var widgetObserver;
  var localeObserver;
  var scheduled = false;

  function currentLocale() {
    var language = document.documentElement.getAttribute('lang') || '';
    return language.toLowerCase().split('-')[0];
  }

  function copyForLocale(review) {
    var locale = currentLocale();
    if (locale === review.sourceLocale) return review.original;
    return review.translations[locale] || null;
  }

  function setText(element, text) {
    if (!element || text === null || typeof text === 'undefined') return;
    if (element.textContent !== text) element.textContent = text;
  }

  function translateKnownReviews() {
    if (!widget || !widget.isConnected) return;

    var reviews = widget.querySelectorAll(REVIEW_SELECTOR);
    for (var index = 0; index < reviews.length; index += 1) {
      var reviewElement = reviews[index];
      var review = REVIEW_DATA[reviewElement.getAttribute('review-uuid')];
      if (!review) continue;

      var copy = copyForLocale(review);
      if (!copy) continue;

      setText(reviewElement.querySelector(TITLE_SELECTOR), copy.title);
      setText(reviewElement.querySelector(BODY_SELECTOR), copy.body);
    }
  }

  function scheduleTranslation() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      translateKnownReviews();
    });
  }

  function attachToWidget() {
    var candidate = document.querySelector(WIDGET_SELECTOR);
    if (!candidate) return;

    if (candidate !== widget) {
      if (widgetObserver) widgetObserver.disconnect();
      widget = candidate;
      widgetObserver = new MutationObserver(scheduleTranslation);
      widgetObserver.observe(widget, { childList: true, subtree: true });
    }

    scheduleTranslation();
  }

  function observeLocale() {
    localeObserver = new MutationObserver(function (mutations) {
      for (var index = 0; index < mutations.length; index += 1) {
        if (mutations[index].attributeName === 'lang') {
          scheduleTranslation();
          return;
        }
      }
    });
    localeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang']
    });
  }

  window.__nomcacheJudgeMeReviewTranslationRenderer = Object.freeze({
    refresh: attachToWidget
  });

  observeLocale();
  document.addEventListener('shopify:section:load', attachToWidget);
  window.addEventListener('languagechange', scheduleTranslation);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachToWidget, { once: true });
  } else {
    attachToWidget();
  }
}());


(function () {
  'use strict';

  var language = (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
  if (language !== 'it') return;

  var sourceLabel = 'Sort reviews by';
  var translatedLabel = 'Ordina le recensioni per';

  function localize(root) {
    root.querySelectorAll('[aria-label], [title]').forEach(function (element) {
      if (element.getAttribute('aria-label') === sourceLabel) {
        element.setAttribute('aria-label', translatedLabel);
      }
      if (element.getAttribute('title') === sourceLabel) {
        element.setAttribute('title', translatedLabel);
      }
    });
  root.querySelectorAll('*').forEach(function (element) {
    if (element.children.length === 0 && element.textContent.trim() === sourceLabel) {
      element.textContent = translatedLabel;
    }
  });
  }

  function findWidget() {
    var root = document.getElementById('judgeme_product_reviews');
    if (!root) return false;

    localize(root);
    var widgetObserver = new MutationObserver(function () { localize(root); });
    widgetObserver.observe(root, {
      attributes: true,
      attributeFilter: ['aria-label', 'title'],
      childList: true,
      subtree: true
    });
    return true;
  }

  if (!findWidget()) {
    var pageObserver = new MutationObserver(function () {
      if (findWidget()) pageObserver.disconnect();
    });
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
